__turbopack_context__.v({
  "hasSecondLevelContinuation": "Question-module__3MO4pa__hasSecondLevelContinuation",
  "question": "Question-module__3MO4pa__question",
  "questionCompleted": "Question-module__3MO4pa__questionCompleted",
  "questionContent": "Question-module__3MO4pa__questionContent",
  "questionError": "Question-module__3MO4pa__questionError",
  "questionIncomplete": "Question-module__3MO4pa__questionIncomplete",
  "questionLastChild": "Question-module__3MO4pa__questionLastChild",
  "questionLevel2": "Question-module__3MO4pa__questionLevel2",
  "questionLevel3": "Question-module__3MO4pa__questionLevel3",
  "questionNumber": "Question-module__3MO4pa__questionNumber",
  "questionNumberContainer": "Question-module__3MO4pa__questionNumberContainer",
  "questionNumberContainerReview": "Question-module__3MO4pa__questionNumberContainerReview",
  "questionPending": "Question-module__3MO4pa__questionPending",
  "questionSeparator": "Question-module__3MO4pa__questionSeparator",
  "questionTarget": "Question-module__3MO4pa__questionTarget",
});
